<template>
  <div class="flex flex-wrap justify-center p2 px3">
    <div class="col-12 md-col-8 center">
      <h2 class="col-12 m0">{{getReferencelabel("YOUR_BALANCE")}}</h2>
      <h1 class="m0 mb3">
        {{ wallet.balance || '0'}} €
      </h1> 
    </div>

    <div class="col-12 flex justify-center">
        <Alert v-if="alertMessage.show" class="mb2" :message="alertMessage.message"  :color="alertMessage.color" />
    </div>

    <WalletInformation :wallet="wallet" />

    <a v-if="showRefundButton" class="col-12 my4 underline pointer center" @click="openRefundModal()">{{getReferencelabel("MAKE_REFUND")}} </a>

    <!-- MODAL  -->
    <Modal v-if="showModal" :maxWidth="'650'" @close="closeModal">
      <template #body>
        <div class="col-12 flex flex-wrap white-bg">
          <h2 class="col-12 m0 pb2 h2n"> {{getReferencelabel("CARD_DETAILS")}} </h2>

            <label class="h6n bold" for="card-number">{{getReferencelabel("CARD_NUMBER")}}</label>
            <input v-model="cardNumber" type="number" id="card-number" class="border col-12 pl2 input-height" />
            <span v-if="invalidCardNumber" class="col-12 red"> {{getReferencelabel('INVALID_CARD_NUMBER')}} </span> 


            <div class="flex flex-wrap"> 
              <label class="col-12 h6n bold pt2">{{getReferencelabel("CARD_EXPIRE_DATE")}}</label>
              <div class="relative"> 
                <input @change="inputDateManual" v-mask="'##/##'" placeholder="12/2025" type="text" v-model="cardDateManual"  class="border col-12 pl2 input-height"/>
                <Datepicker 
                id="refundDatePicker"
                style="position:absolute; top:26px; left:157px"
                v-model="cardDate" 
                monthPicker 
                @update:modelValue="datePickerInput"
                :minDate="minDateAvaliable()"
                textInput > </Datepicker>
               </div>
                  <span v-if="invalidCardDate" class="col-12 red"> {{getReferencelabel('INVALID_CARD_DATE')}} </span> 

            </div>

            <div class="col-12 center pt2" >
              <Button reference="MAKE_REFUND" class="inline-block col-12 md-col-6 mt2"  :disabled="allowRefund" btn-color="blue" :action="makeRefund" />
            </div>
        </div>
      </template>
    </Modal>

  </div>
</template>
<script>
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ref, provide, computed } from 'vue'
import { getReferencelabel } from '@/mixins/utils';
import { walletRefund } from '@/mixins/requests';

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import Modal from '@/components/blocks/Modal';
import WalletInformation from "@/components/services/WalletInformation";
import Button from '@/components/elements/Button';
import Alert from '@/components/common/Alert';


export default {
  components: {
    WalletInformation,
    Modal,
    Datepicker,
    Button,
    Alert
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const showModal = ref(false);
    const cardDate = ref(null)
    const cardDateManual = ref('')
    const cardNumber = ref(null)
    const invalidCardNumber = ref(false)
    const invalidCardDate = ref(false)
    
    const alertMessage = ref({
      show: false
    })

    const textInputOptions = ref({
        format: 'MM/yyyy',
        enterSubmit: true,
        rangeSeparator: '/'
      })

    const wallet = store.state.wallets.find((a) => a.uuid === route.params.id);

    function openRefundModal () {
      showModal.value = true
    }

    function minDateAvaliable () {
      const date = new Date()
      return new Date(date.setMonth(date.getMonth() - 1))
    }

    const allowRefund = computed (() => {
      return !cardDate.value || !cardNumber.value || !showRefundButton 
    })

    const showRefundButton = computed (() => {
        return  wallet.balance !== 0
    })

    async function makeRefund () {
      if(!cardNumber.value || cardNumber.value &&  cardNumber.value.toString().length !== 16 ) {
        invalidCardNumber.value = true
        return
      }

      invalidCardNumber.value = false
      store.commit('setLoading', true);
      // MAKE REFUND
      const data = {
          cardNumber: cardNumber.value.toString(),
          cardDate: `${cardDate.value.month + 1}${cardDate.value.year % 100}`.padStart(4, "0"),
          amount: parseFloat(wallet.balance),
          wallet_uuid: wallet.uuid
      } 

      const response = await walletRefund(data)
      alertMessage.value.show = true

      if(response.success) {
        wallet.balance = 0
        alertMessage.value.message = "REFUND_SUCCESS"
        alertMessage.value.color = 'success'
      } else {
        alertMessage.value.color = 'error'
        alertMessage.value.message =  response?.data?.code === "00021" ? "INVALID_CARD_NUMBER" : "REFUND_FAILED"
      }
      
      cardDate.value = null
      cardNumber.value = null
      showModal.value = false
      cardDateManual.value = ''
      store.commit('setLoading', false);
    }

    function datePickerInput () {
      cardDateManual.value = `${cardDate.value.month + 1}/${cardDate.value.year}`
    }

    function inputDateManual () {
      if(cardDateManual.value) {
        const parsedDate = cardDateManual.value.split('/')
        const date = new Date(parsedDate[1], parsedDate[0] - 1)
        const today = new Date()
        today.setMonth(today.getMonth() - 1);

        if(date == 'Invalid Date' || today.getTime() > date.getTime() ) {
          invalidCardDate.value = true
          return  
        }
        cardDate.value = {
          year: date.getFullYear(),
          month: date.getMonth()
        }
        invalidCardDate.value = false
      }
      
    }

    return { 
      cardDateManual,
      invalidCardDate,
      inputDateManual, 
      wallet, 
      getReferencelabel, 
      showModal, 
      openRefundModal,
      cardDate,  
      datePickerInput,
      minDateAvaliable, 
      makeRefund, 
      cardNumber, 
      invalidCardNumber, 
      allowRefund, 
      alertMessage, 
      showRefundButton,
      textInputOptions};
  },
};
</script>
<style> 
#refundDatePicker  .dp__input  {
  display: none;
}
#refundDatePicker  .dp__clear_icon {
  display: none;
}

</style> 
